import { gql } from 'urql';

const FetchEmployeeStatus = gql`
  query FetchEmployeeStatus {
    employmentTypes {
      id
      name
    }
  }
`;

export default FetchEmployeeStatus;
